const e = {
  undo: "Fortryd",
  redo: "Lav om",
  confirm: "Bekræft",
  clear: "Fjern",
  more: "mere",
  cancel: "Annuller",
  update: "Opdater"
}, t = {
  positiveText: "Bekræft",
  negativeText: "Annuller"
}, r = {
  placeholder: "Vælg",
  loading: "Indlæser"
}, l = {
  clear: "Fjern",
  now: "Nu",
  confirm: "Bekræft",
  selectTime: "Vælg tidspunkt",
  selectDate: "Vælg dato",
  datePlaceholder: "Vælg dato",
  datetimePlaceholder: "Vælg dato og tidspunkt",
  monthPlaceholder: "Vælg måned",
  yearPlaceholder: "Vælg år",
  quarterPlaceholder: "Vælg kvartal",
  startDatePlaceholder: "Startdato",
  endDatePlaceholder: "Slutdato",
  startDatetimePlaceholder: "Startdato- og tidspunkt",
  endDatetimePlaceholder: "Slutdato- og tidspunkt",
  startMonthPlaceholder: "Startmåned",
  endMonthPlaceholder: "Slutmåned",
  today: "I dag"
}, a = {
  checkTableAll: "Vælg alle i tabellen",
  uncheckTableAll: "Fravælg alle i tabellen",
  confirm: "Bekræft",
  clear: "Fjern",
  apply: "Anvend",
  filters: "Filtre",
  sort: "Sortér"
}, n = {
  sourceTitle: "Kilde",
  targetTitle: "Mål"
}, o = {
  selectAll: "Vælg alle",
  unselectAll: "Fravælg alle",
  clearAll: "Fjern"
}, i = {
  description: "Ingen info"
}, d = {
  placeholder: "Vælg"
}, c = {
  placeholder: "Vælg tidspunkt",
  positiveText: "Ok",
  negativeText: "Annuller",
  now: "Nu"
}, s = {
  goto: "Goto",
  selectionSuffix: "side",
  next: "Næste",
  previous: "Tidligere"
}, g = {
  add: "Tilføj"
}, u = {
  loading: "Indlæser"
}, p = {
  placeholder: "Indtast"
}, m = {
  placeholder: "Indtast"
}, f = {
  create: "Opret"
}, k = {
  title: "Temaeditor",
  clearAllVars: "Fjern alle variabler",
  clearSearch: "Ryd søgning",
  filterCompName: "Filter modulnavn",
  filterVarName: "Filtervariabelnavn",
  import: "Importér",
  export: "Eksportér",
  restore: "Nulstil til standard"
}, h = {
  tipPrevious: "Tidligere billede (←)",
  tipNext: "Næste billede (→)",
  tipCounterclockwise: "Mod uret",
  tipClockwise: "Med uret",
  tipZoomOut: "Zoom ud",
  tipZoomIn: "Zoom ind",
  tipClose: "Luk (Esc)",
  tipOriginalSize: "Zoom til original størrelse"
}, T = {
  heading: "Sortér og filtre",
  sortHeading: "Sortér efter",
  newestFirst: "Nyeste først",
  oldestFirst: "Ældste først",
  ascending: "Stig",
  descending: "Fald",
  apply: "Anvend",
  clear: "Fjern",
  cancel: "Annuller",
  filters: "Filtre"
}, v = {
  noMatchingFound: "Der blev ikke fundet nogen matchende resultater"
}, P = {
  margin: "Margin",
  padding: "Polstring",
  reset: "Nulstil",
  errorMsg: "Den udstedte værdi er ugyldig."
}, S = {
  brandColors: "Brandfarver",
  noBrandColors: "Du har ikke tilføjet nogen brandfarver endnu.",
  getStarted: "Kom i gang",
  add: "Tilføj",
  default: "Standard"
}, F = {
  addColor: "Tilføj ny farve",
  editColor: "Rediger farve",
  add: "Tilføj",
  noData: "Du har ikke tilføjet nogen farver endnu.",
  invalidCode: "Ugyldig farvekode",
  defaultColor: "Standardfarver"
}, y = {
  global: e,
  Popconfirm: t,
  Cascader: r,
  DatePicker: l,
  DataTable: a,
  LegacyTransfer: n,
  Transfer: o,
  Empty: i,
  Select: d,
  TimePicker: c,
  Pagination: s,
  DynamicTags: g,
  Log: u,
  Input: p,
  InputNumber: m,
  DynamicInput: f,
  ThemeEditor: k,
  Image: h,
  SortFilter: T,
  IconPicker: v,
  Spacing: P,
  BrandColorPicker: S,
  BrandBoard: F
};
export {
  F as BrandBoard,
  S as BrandColorPicker,
  r as Cascader,
  a as DataTable,
  l as DatePicker,
  f as DynamicInput,
  g as DynamicTags,
  i as Empty,
  v as IconPicker,
  h as Image,
  p as Input,
  m as InputNumber,
  n as LegacyTransfer,
  u as Log,
  s as Pagination,
  t as Popconfirm,
  d as Select,
  T as SortFilter,
  P as Spacing,
  k as ThemeEditor,
  c as TimePicker,
  o as Transfer,
  y as default,
  e as global
};
